import { css } from "@emotion/css";
import MaterialDialog from "@mui/material/Dialog";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
export interface DialogProps {
    open: boolean;
    dialogWidth?: "480px" | "600px" | "800px" | "1000px";
    fullScreen?: boolean;
    children?: React.ReactNode;
}
export function Dialog(props: DialogProps) {
    const { open, children, fullScreen, dialogWidth = "600px" } = props;
    // Dialogs are used in portals, however because react uses synthetic events, events in the dialog will bubble up the react tree rather than the dom tree.
    // This means that clicks inside the dialog can trigger click handlers on parent react components such as redirects on list rows.
    // This can be prevented by stopping the event propagation at the root of the dialog.
    const stopEventPropagation = React.useCallback((event: React.MouseEvent) => event.stopPropagation(), []);
    return (<MaterialDialog className={styles.paper(dialogWidth)} maxWidth={false} open={open || false} fullScreen={fullScreen} onClick={stopEventPropagation}>
            {open && children}
        </MaterialDialog>);
}
const styles = {
    paper: (maxWidth: DialogProps["dialogWidth"]) => css({
        ".MuiDialog-paperWidthFalse": {
            maxWidth,
            width: "100%",
            backgroundColor: themeTokens.color.dialog.background.primary,
        },
    }),
};
Dialog.displayName = "Dialog";
